import { ELoanUsage, setLoanUsage } from '@/context/borrower';
import { store } from '@/context/store';
import { IParameter } from '@/utils/setParametersFromParams';

export function setInitialLoanUsage(
    partnerLoanUsage: ELoanUsage,
    parameterLoanUsage: IParameter
): void {
    let loanUsageToSave = (
        partnerLoanUsage ?? parameterLoanUsage
    )?.toUpperCase();

    // Map NOVATED_LEASE to NOVATED for compatibility
    if (loanUsageToSave === 'NOVATED_LEASE') {
        loanUsageToSave = 'NOVATED';
    }

    if (!loanUsageToSave || !(loanUsageToSave in ELoanUsage)) {
        return;
    }

    const stateLoanUsage = store.getState().borrowerReducer.loan.loanUsage;

    if (stateLoanUsage !== loanUsageToSave) {
        store.dispatch(setLoanUsage(loanUsageToSave as ELoanUsage));
    }
}
